import { render } from "./SearchGlass.vue?vue&type=template&id=04960dd4"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/SearchGlass.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "04960dd4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('04960dd4', __exports__)) {
    api.reload('04960dd4', __exports__)
  }
  
  module.hot.accept("./SearchGlass.vue?vue&type=template&id=04960dd4", () => {
    api.rerender('04960dd4', render)
  })

}


export default __exports__